import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
function ScrollToTop(_a) {
    var history = _a.history;
    useEffect(function () {
        var unlisten = history.listen(function () {
            window.scrollTo(0, 0);
        });
        return function () {
            unlisten();
        };
    }, []);
    return (null);
}
export default withRouter(ScrollToTop);
